import React from 'react';
import PropTypes from 'prop-types';
import { ThemeProvider } from 'react-css-themr';
import { Card, CardText } from 'react-toolbox';
import card from './card';

const theme = {
  RTCard: card,
};

const Unauthorized = ({ restrictedItem, additionalMessage }) => <ThemeProvider theme={theme}>
  <Card>
    <CardText>
      <p>You are not authorized to access this {restrictedItem || 'page'}.</p>
      {additionalMessage && <p>{additionalMessage}.</p>}
    </CardText>
  </Card>
</ThemeProvider>;

Unauthorized.defaultProps = {
  restrictedItem: '',
  additionalMessage: '',
};

Unauthorized.propTypes = {
  restrictedItem: PropTypes.string,
  additionalMessage: PropTypes.string,
};

export default Unauthorized;



// WEBPACK FOOTER //
// ./client/app/shared/components/Unauthorized/index.jsx